<h2 mat-dialog-title>O seu endereço corresponde à algum destes complementos?</h2>
<div mat-dialog-content>
  <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" [(ngModel)]="itemSelected">
    <mat-radio-button class="radio-button" *ngFor="let item of data" [value]="item.id">
      {{item?.complemento}}
    </mat-radio-button>
    <mat-radio-button class="radio-button" value="Outro">
      Não é nenhum destes complementos
    </mat-radio-button>
  </mat-radio-group>
</div>
<div mat-dialog-actions>
  <button mat-button cdkFocusInitial (click)="onNoClick()">Cancelar</button>
  <button mat-button (click)="onYesClick()">Sim</button>
</div>